var _rect, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRoadmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1040,
    height: 37,
    viewBox: "0 0 1040 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.232,
    y: 19.2116,
    width: 1.42308,
    height: 1001.63,
    transform: "rotate(-90 19.232 19.2116)",
    stroke: "url(#paint0_linear_497_44)",
    strokeWidth: 1.42308
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5205,
    cy: 18.5,
    rx: 18.5,
    ry: 18.5205,
    transform: "rotate(-90 18.5205 18.5)",
    fill: "#37BD6A",
    fillOpacity: 0.2
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5207,
    cy: 18.5005,
    rx: 14.0627,
    ry: 14.0783,
    transform: "rotate(-90 18.5207 18.5005)",
    fill: "#37BD6A",
    fillOpacity: 0.3
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5206,
    cy: 18.5002,
    rx: 9.61683,
    ry: 9.62751,
    transform: "rotate(-90 18.5206 18.5002)",
    fill: "#37BD6A",
    fillOpacity: 0.4
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.5204,
    cy: 18.5001,
    rx: 4.93536,
    ry: 4.94084,
    transform: "rotate(-90 18.5204 18.5001)",
    fill: "#37BD6A"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.26,
    cy: 18.5,
    rx: 18.5,
    ry: 18.5205,
    transform: "rotate(-90 269.26 18.5)",
    fill: "#FEAC56",
    fillOpacity: 0.2
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.26,
    cy: 18.5005,
    rx: 14.0627,
    ry: 14.0783,
    transform: "rotate(-90 269.26 18.5005)",
    fill: "#FEAC56",
    fillOpacity: 0.3
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.26,
    cy: 18.5002,
    rx: 9.61683,
    ry: 9.62751,
    transform: "rotate(-90 269.26 18.5002)",
    fill: "#FEAC56",
    fillOpacity: 0.4
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 269.26,
    cy: 18.5001,
    rx: 4.93536,
    ry: 4.94084,
    transform: "rotate(-90 269.26 18.5001)",
    fill: "#FEAC56"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 18.5,
    rx: 18.5,
    ry: 18.5205,
    transform: "rotate(-90 520 18.5)",
    fill: "#FF7253",
    fillOpacity: 0.2
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 18.5005,
    rx: 14.0627,
    ry: 14.0783,
    transform: "rotate(-90 520 18.5005)",
    fill: "#FF7253",
    fillOpacity: 0.3
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 18.5002,
    rx: 9.61683,
    ry: 9.62751,
    transform: "rotate(-90 520 18.5002)",
    fill: "#FF7253",
    fillOpacity: 0.4
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520,
    cy: 18.5001,
    rx: 4.93536,
    ry: 4.94084,
    transform: "rotate(-90 520 18.5001)",
    fill: "#FF7253"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.74,
    cy: 18.5,
    rx: 18.5,
    ry: 18.5205,
    transform: "rotate(-90 770.74 18.5)",
    fill: "#9C56F5",
    fillOpacity: 0.2
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.74,
    cy: 18.5005,
    rx: 14.0627,
    ry: 14.0783,
    transform: "rotate(-90 770.74 18.5005)",
    fill: "#9C56F5",
    fillOpacity: 0.3
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.74,
    cy: 18.5002,
    rx: 9.61683,
    ry: 9.62751,
    transform: "rotate(-90 770.74 18.5002)",
    fill: "#9C56F5",
    fillOpacity: 0.4
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 770.74,
    cy: 18.5001,
    rx: 4.93536,
    ry: 4.94084,
    transform: "rotate(-90 770.74 18.5001)",
    fill: "#9C56F5"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1021.48,
    cy: 18.5,
    rx: 18.5,
    ry: 18.5205,
    transform: "rotate(-90 1021.48 18.5)",
    fill: "#3C66FC",
    fillOpacity: 0.2
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1021.48,
    cy: 18.5005,
    rx: 14.0627,
    ry: 14.0783,
    transform: "rotate(-90 1021.48 18.5005)",
    fill: "#3C66FC",
    fillOpacity: 0.3
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1021.48,
    cy: 18.5002,
    rx: 9.61683,
    ry: 9.62751,
    transform: "rotate(-90 1021.48 18.5002)",
    fill: "#3C66FC",
    fillOpacity: 0.4
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1021.48,
    cy: 18.5001,
    rx: 4.93536,
    ry: 4.94084,
    transform: "rotate(-90 1021.48 18.5001)",
    fill: "#3C66FC"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_497_44",
    x1: 19.9436,
    y1: 19.9231,
    x2: 19.9435,
    y2: 1022.97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#37BD6A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FEAC56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF7253"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#9C56F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C66FC"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmap);
export default __webpack_public_path__ + "static/media/roadmap.2bc533ee8db48a35fef1e2027e07943a.svg";
export { ForwardRef as ReactComponent };